export default {
  name: "LsLogo",
  width: 112,
  height: 43,
  viewBox: "0 0 112 43",
  g: [
    {
      fill: "#e7b923",
      d:
        "M111.06 5.08c1.72 2.65.82 5.67-1.08 7.44a6.8 6.8 0 0 1-3.86 1.76c-1.2.17-2.43.12-3.62-.13-.67-.2-1.31-.47-1.92-.8a7.44 7.44 0 0 0-.72-2.6c-.18-.4-.42-.76-.71-1.08a7 7 0 0 0 .32-5.3 2.93 2.93 0 0 0-2.16-1.6c.28-.4.6-.77.94-1.12 3.12-3.21 10.3-.42 12.82 3.43",
    },
    {
      fill: "#5fb8de",
      d:
        "M94.5 9.74c-.3.23-.59.5-.83.79a5.1 5.1 0 0 1-2.1-4.07c-.04-2.08.52-3.08 2.58-3.55a7.47 7.47 0 0 1 3.18-.13 6 6 0 0 0-.74 6.07 5 5 0 0 0-2.09.9",
    },
    {
      fill: "#638339",
      d:
        "M96.6 8.85a6 6 0 0 1 .73-6.07c.93.15 1.74.75 2.16 1.6a6.96 6.96 0 0 1-.32 5.3c-.2-.22-.43-.4-.68-.55-.58-.3-1.25-.4-1.9-.28",
    },
    {
      fill: "#e90c8b",
      d:
        "M97.71 10.78c.38.5.8.98 1.25 1.42.48.47 1.03.85 1.62 1.14.06.7-.16 1.4-.61 1.92-1.94 2.37-3.8 2.83-5.7 1.76.1-.51.04-1.04-.14-1.54-.3-.63-.98-.77-1.64-.74a5.02 5.02 0 0 1 1.18-4.22c.68.47 1.52.69 2.35.6a5 5 0 0 0 1.7-.33",
    },
    {
      fill: "#c12429",
      d:
        "M99.16 9.67a4 4 0 0 1 .7 1.09c.4.81.65 1.69.73 2.59-.6-.3-1.14-.68-1.62-1.14-.45-.45-.87-.92-1.25-1.42.25-.11.5-.23.74-.37.28-.2.52-.45.7-.75",
    },
    {
      fill: "#6d2977",
      d:
        "M96.01 11.12a3.56 3.56 0 0 1-2.34-.6 4.8 4.8 0 0 1 2.92-1.67c.3.69.67 1.33 1.12 1.93-.54.2-1.11.32-1.7.34",
    },
    {
      fill: "#739143",
      d:
        "M97.2 8.82c.43 0 .86.1 1.24.29l.05.02c.25.14.48.33.67.54-.17.3-.4.56-.7.75-.23.14-.48.26-.73.37a8.9 8.9 0 0 1-1.14-1.94h.03c.17-.03.35-.04.53-.04",
    },
    {
      fill: "#69252d",
      d:
        "M98.47 9.13c.26.15.49.33.68.55-.17.3-.4.55-.7.74-.23.14-.48.26-.74.37a8.89 8.89 0 0 1-1.13-1.94 2.92 2.92 0 0 1 1.9.28",
    },
    {
      fill: "#ef8128",
      d:
        "M92.5 14.75c.21.9.78 1.67 1.57 2.15l.22.13c0 .44-.22.85-.58 1.1-.32.2-.7.3-1.07.31-1.1.1-1.94-.97-1.94-2.04-.02-.91.22-1.35 1.12-1.55.22-.06.45-.1.67-.1",
    },
    {
      fill: "#e4232b",
      d:
        "M92.7 14.75c.58-.07 1.14.22 1.43.73a3.32 3.32 0 0 1 .14 1.54l-.22-.13a3.4 3.4 0 0 1-1.56-2.15h.2",
    },
    {
      fill: "#cf1f41",
      d:
        "M94.15 15.48c.17.5.21 1.03.12 1.55l-.23-.14a3.4 3.4 0 0 1-1.56-2.15c.67-.04 1.37.1 1.67.74",
    },
    {
      d:
        "M5.86 22.66a1.1 1.1 0 1 1 2.2 0v11.45a1.1 1.1 0 1 1-2.2 0V22.66zm17.07 0a1.1 1.1 0 1 1 2.2 0v11.45a1.1 1.1 0 1 1-2.2 0V22.66zm27.35 6.43c0 2.02-1.25 4.07-3.1 4.07-3.2 0-3.3-3.22-3.3-4.86 0-3.32 1.56-5.08 3.82-5.08.87-.01 1.75.12 2.58.4v5.47zm-.02 6.84c0 2.92-.7 5.19-3.19 5.19-1.36 0-2.3-.62-2.3-2.04 0-1.2 1.22-2.26 2.55-3.4l2.93-2.54.01 2.79zm.7-14.06c-.97-.25-1.97-.4-2.98-.41-3.29 0-6.28 2.28-6.28 6.65 0 4.68 2.02 6.38 4.37 6.6l-.47.32c-1.38.94-2.88 2.01-2.88 4.07 0 2.15 1.43 3.66 4.19 3.66 5.2 0 5.4-4.91 5.4-7.82v-11.2c0-1.46-.38-1.64-1.33-1.87m58.82-4.6a1.1 1.1 0 1 1 2.2 0v17.02a1.1 1.1 0 1 1-2.2 0V17.26zM0 17.27a1.1 1.1 0 0 1 1.07-1.14h.02c.61 0 1.1.5 1.1 1.11V34.3a1.1 1.1 0 1 1-2.19 0V17.27zm18.4 4.98a1.06 1.06 0 1 1 1.97.8l-4.13 11.27c-.18.5-.42.91-.98.91-.55 0-.74-.39-.95-.91l-4.1-11.18c-.31-.84.1-1.58.96-1.58.44 0 .84.29 1 .71l3.14 8.62 3.09-8.64zm18.37 4.34c0-1.83-.61-3.35-2.7-3.35-1.9 0-3.41 1.97-3.41 4.3v6.6a1.1 1.1 0 1 1-2.2 0V22.69a1.06 1.06 0 1 1 2.1 0v.89c.8-1.38 2.3-2.2 3.89-2.12 2.83 0 4.5 1.53 4.5 4.6v8.08a1.1 1.1 0 1 1-2.2 0l.02-7.55zm18.47 5.96c.24.01.46.08.66.2.9.54 1.94.83 2.99.84 1.4 0 2.47-.67 2.47-2.12s-1.36-1.95-2.83-2.43c-1.8-.6-3.74-1.25-3.74-3.76 0-2.67 2.1-3.86 4.42-3.86a6.36 6.36 0 0 1 3.46.99c.32.16.54.47.57.83a.86.86 0 0 1-.84.92 1.57 1.57 0 0 1-.75-.28 4.78 4.78 0 0 0-2.53-.64c-1.06 0-2.26.42-2.26 1.87 0 1.35 1.38 1.86 2.78 2.31 1.75.6 3.8 1.47 3.8 3.96 0 2.62-1.83 3.98-4.52 3.98a7.53 7.53 0 0 1-3.9-1.01 1 1 0 0 1-.6-.87.86.86 0 0 1 .83-.92m15.71 1.05c-2.9 0-3.53-3.01-3.53-5.55 0-2.79 1.25-4.82 3.62-4.82 2.44 0 3.46 2.15 3.46 5.24 0 2.8-1.17 5.14-3.55 5.14m.25-12.16c-2.6 0-5.98 1.36-5.98 6.85 0 4.77 2.2 7.06 5.55 7.06 3.28 0 5.97-2.15 5.97-7.32 0-6-3.73-6.58-5.55-6.58m15.78 11.36c.31-.21.68-.35 1.06-.39a.8.8 0 0 1 .82.87c0 .35-.2.66-.5.84a7.42 7.42 0 0 1-4.02 1.22c-3.74 0-5.75-2.42-5.75-6.95 0-5.4 3.26-6.95 5.73-6.95a6.05 6.05 0 0 1 4.07 1.42c.23.2.37.48.37.78a.93.93 0 0 1-.87.98h-.04a1.52 1.52 0 0 1-.86-.37c-.72-.66-1.67-1-2.65-.96-2.04 0-3.55 1.56-3.55 5.02 0 3.04 1.06 5.2 3.76 5.2.86-.01 1.7-.25 2.43-.7m3.66-10.15a1.1 1.1 0 1 1 2.2 0v11.45a1.1 1.1 0 1 1-2.2 0V22.69zm13.58 6.38c0 1.78-1.22 4.6-3.89 4.6-2.03 0-2.67-2.38-2.67-4.6 0-3.3 1.04-5.8 4.07-5.8.86-.02 1.7.13 2.51.41l-.02 5.39zm1.1-7.11a14.52 14.52 0 0 0-3.24-.5c-4.37 0-6.6 2.83-6.6 7.52 0 3.84 1.54 6.38 4.76 6.38a4.4 4.4 0 0 0 4.08-2.47v1.26c-.03.58.42 1.08 1 1.1h.06a1.05 1.05 0 0 0 1.04-1.12V23.68c0-.96-.12-1.46-1.1-1.74",
    },
  ],
}
